<template>
    <div class="col-lg-4">
        <div class="propertyaddress-box">
            <div class="address-info d-flex align-items-center justify-content-center skiptranslate" :id="parentDivId">
                <i class="icon icon-pin mr-2 d-flex justify-content-center" aria-hidden="true"></i>

                <EllipsisParagraph  class="address-box__title d-block justify-content-center">
                    {{ address.displayName }}
                </EllipsisParagraph>
                <!-- <p :id="childPrgphId" class="address-box__title d-block justify-content-center" 
                    v-b-popover.hover.bottom="checkIfPopoverWillDisplay(address.displayName)" 
                    :style="checkIfPopoverWillDisplay(address.displayName) ? this.hasEllipsis : this.default">
                    {{ address.displayName }}
                </p> -->
            </div>
            <div class="btn-list">
                <a class="button btn-unpin btn--cpointer" :style="'color:' + MainUISettings.button_color" @click.prevent="unpin(address)" tabindex="0" @keydown="event => {unpinKeyEvent(event, address) }">
                    <i class="icon icon-pushpinfill" aria-hidden="true"></i>
                    <span>{{ TEXTS.render(`FAVOURITE_ADDRESS_ITEM_UNPIN`) }}</span>
                </a>
                <a class="button btn-history btn--cpointer disabled" :style="'color:' + MainUISettings.button_color" @click.prevent="bookingHistory(address, address.id)" tabindex="0" @keydown="event => {bookingHistoryKeyEvent(event, address, address.id) }">
                    <i class="icon icon-education" aria-hidden="true"></i>
                    <span>{{ $store.getters.GET_SITE_WORDINGS.bookhistory_button_label || pinnedAddressBookingHistoryBtnText }}</span>
                </a>
                <a class="button btn-book btn--cpointer" :style="'color:' + MainUISettings.button_color" @click.prevent="bookNow(address)" tabindex="0" @keydown="event => {bookNowKeyEvent(event, address) }">
                    <i class="icon icon-check" aria-hidden="true"></i>
                    <span>{{ favoriteBookNow }}</span>   
                </a> 
            </div>
        </div>
    </div>
</template>
<script>
    import BookingStateManager from '../../../../common/utils/BookingStateManager';
    import EllipsisParagraph from '../../../../common/components/EllipsisParagraph'
    import Texts from '../../../../common/utils/Texts'
    import GeneralBookingSettingMixin from '../../../../common/mixins/GeneralBookingSettingMixin';
    import BookingAddressMixin from '../../../../common/mixins/BookingAddressMixin';

    export default {
        mixins: [GeneralBookingSettingMixin, BookingAddressMixin],
        components : {
            EllipsisParagraph
        },
        data() {
            return {
                hasEllipsis: {
                    'white-space': 'nowrap',
                    'overflow': 'hidden',
                    'text-overflow': 'ellipsis',
                    '-webkit-line-clamp': 2,
                    'width': '90%'
                },
                default: {
                    'width': 'auto',
                    'flex-shrink':'0'
                    //'position': 'absolute'
                },
                window: {
                    width: 0,
                },
                timerId: null,
            }
        },
        props: {
            address: Object,
            index : Number
        },
        methods: {
            unpin(address) {
                this.$store.dispatch('postFavorite', [address, 'remove-favorite'])
                    .then(() =>{
                        Toastify({
                            text: Texts.render(`FAVOURITE_ADDRESS_ITEM_UNPIN_SUCCESS`),
                            duration: 3000,
                            gravity: "bottom",
                            position: 'right', 
                            offset: {
                                x: '2rem',
                                y: '2rem'
                            },
                            style: {
                                background: '#00B029'
                            },
                            onClick: function(){} // Callback after click
                        }).showToast();
                    });;
            },
            unpinKeyEvent(event, address){
                if (event.keyCode == 32 || event.keyCode == 13) {
                    event.preventDefault();
                    this.unpin(address)
                }
            },
            bookingHistory(address, id) {
                this.$store.dispatch('setActiveAddress', address);

                var bookingManager = new BookingStateManager();
                bookingManager.upsertAddressMap(address)
                this.$router.push({ path: 'history', query: { id: id }})
            },
            bookingHistoryKeyEvent(event, address, id){
                if (event.keyCode == 32 || event.keyCode == 13) {
                    event.preventDefault();
                    this.bookingHistory(address, id)
                }
            },
            bookNow(activeAddress){
                if(!activeAddress){
                    return;
                }

                if (this.searchAddressToList(activeAddress.displayName)) {
                    window.eventBus.$emit(
                        "alertDoubleBooking",
                        this.TEXTS.render(`BOOKING_FORM_MULTIPLE_BOOKING_ERROR_MESSAGE`)
                    );
                    return false;
                }
                this.addToAddressList(activeAddress.displayName);
                this.$store.dispatch('setActiveAddress', activeAddress);
                //Resets Step Form Index
                this.$store.dispatch('resetStepFormIndex');
                var bookingManager = new BookingStateManager();
                var transaction = bookingManager.newBooking(activeAddress);
                
                // Verify if complete
                if(transaction && transaction.id && transaction.activeAddress) {
                    var userType = this.$store.getters.GET_PERSONAL_INFO.type;
                    switch(userType){
                        case 'cso': // CSO Users have the booking opened on a new tab (US-68)
                            var routeOptions = { 
                                path: transaction.url.form
                            };
                            let routeData = this.$router.resolve(routeOptions);
                            window.open(routeData.href, '_blank'); 
                            break;
                        default:
                            this.$router.push(transaction.url.form);
                            break;
                    }
                }
            },
            bookNowKeyEvent(event, activeAddress){
                if (event.keyCode == 32 || event.keyCode == 13) {
                    event.preventDefault();
                    this.bookNow(activeAddress)
                }
            },
            //Filter each addresses and checking the width on the favourites list
            checkIfPopoverWillDisplay(data) {
                var parentDiv = document.getElementById(this.parentDivId);
                var childTextDiv = document.getElementById(this.childPrgphId);
                
                if(parentDiv && childTextDiv && this.window.width) {
                    var parentCss = window.getComputedStyle(parentDiv);
                    var childCss = window.getComputedStyle(childTextDiv);
                    var childText = childTextDiv.innerHTML;

                    var parentWidth = parseInt(parentCss.width) - 48;
                    var childFont = childCss["font-size"];
                    
                    if(Math.ceil(childTextDiv.scrollWidth)> Math.ceil(parentWidth)) {
                        return data;
                    } 
                    return false;
                }
            },
            //Check width of the browser/ device when resizing
            handleResize(event) {
                if (this.timerId) {
                    clearTimeout(this.timerId);
                }
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                    this.window.width = window.innerWidth;
                }, 100);

                return this.window.width;
            }
        },
        computed: {
            TEXTS : () => Texts,
            MainUISettings() {
                return this.$store.getters['GET_MAIN_UI']; 
            },
            parentDivId() {
                var index = this.index;
                return "address-info-" + index;
            },
            childPrgphId() {
                var index = this.index;
                return "address-title" + index;
            },
            favoriteBookNow() {
                let bookNowText = (this.siteWording || Texts.render(`FAVOURITE_ADDRESS_ITEM_BOOK`)).trim();
                return bookNowText.split(' ')[0];
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
    }
</script>